import { centeredBoxSx } from 'components/styles/container';
import { Box, CircularProgress } from 'components/ui';

const Loader = () => {
  return (
    <Box sx={centeredBoxSx}>
      <CircularProgress />
    </Box>
  );
};

export default Loader;
